import { TextField } from "../../../atoms/Form";
import { type ConstructedTextField } from "../types";

export const FIELD_NAME_FIRST_NAME = "firstName";

const tLabel = "First Name";
const tRequired = "First name is required";
const tLengthMax = "First name cannot exceed 200 characters";
const tLengthMin = "First name must be at least 2 characters";

export type FirstNameProps = ConstructedTextField & { required?: boolean };

export const FirstName = ({ textFieldProps, ...props }: FirstNameProps) => {
  return (
    <TextField
      name={FIELD_NAME_FIRST_NAME}
      textFieldProps={{
        inputProps: { maxLength: 200, minLength: 2 },
        label: tLabel,
        ...props,
        ...textFieldProps,
      }}
      validate={(value, _, meta) => {
        if (props.required && meta?.modified && !value) {
          return tRequired;
        }

        if (meta?.dirty && value) {
          if (value.length < 2) {
            return tLengthMin;
          }

          if (value.length > 200) {
            return tLengthMax;
          }
        }

        return "";
      }}
      {...props}
    />
  );
};
